export enum VehicleHistory {

  // Kleiner Kundendienst
  MINOR_SERVICE = 'MINOR_SERVICE',
  // Großer Kundendienst
  MAJOR_SERVICE = 'MAJOR_SERVICE',
  // Hauptuntersuchung
  TECHNICAL_INSPECTION = 'TECHNICAL_INSPECTION',
  // Abgasuntersuchung
  EMISSIONS_TEST = 'EMISSIONS_TEST',
  // Reifenwechsel
  TIRE_CHANGE = 'TIRE_CHANGE',
  // Ölwechsel
  OIL_CHANGE = 'OIL_CHANGE',
  // Getriebe-Ölwechsel
  TRANSMISSION_OIL_CHANGE = 'TRANSMISSION_OIL_CHANGE',
  // Steuerkette / Steuerriemen Wechsel
  TIMING_CHAIN_BELT_CHANGE = 'TIMING_CHAIN_BELT_CHANGE',
  // (Vorgeschlagene) Reparatur
  RECOMMENDED_REPAIR = 'RECOMMENDED_REPAIR',
}
